var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('baidu-map',{staticClass:"map",attrs:{"center":_vm.center,"zoom":15,"scroll-wheel-zoom":true,"ak":"ApDQTUF556xyzFgFZAoa2WVJVdbJtPOH"},on:{"ready":_vm.handleMapReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }